import { request } from '@kibt/krn-utils';
import { $k18n } from './i18n';
import { radar, webLogger } from './log';
import { Toast } from '@kibt/meta-ui-krn';
import { setPrestoreDataFromRes } from './prestoreDetail';
import { getUrlPathname } from './url';
import { useLoginStore } from '@/component/LoginSdk/store/useLoginStore';
import cookies from 'js-cookie';
import { getEnvByUrl, isDev, isProd, isPRT, isStaging } from '@/common/api';

// 接口返回403并不进行拦截的接口
// 举例：如需要忽略rest/info, 这个接口及时返回403，也不弹窗；
const UN_AUTHORIZED_OMIT = [];
// 按页面豁免
// 这个页面的接口都豁免
const UN_AUTHORIZED_OMIT_PATHNAME = ['/shop/detail/'];
/**
 * 全局异常拦截器
 * 注意：KRN场景下和一码多投H5场景下参数不一样
 * 1.KRN场景下：可以获得response: any, originResponse: any, request: any, originRequest: any, extraConfig?: any 五个参数
 * 2.H5场景下：亚杰最初封装的时候返回了reponse.data，不是AxiosResponse对象，因进而获取不到AxiosRequestConfig，  由于现在已经被各业务大量使用不好改了，后面如果有需求再看怎么统一结构吧
 */

/**
 * 全局异常拦截器有问题，如果出现异常，出触发两次，后面@chengyajie 修复，目前先通过业务代码来节流处理
 */
const throttleToastObj = {
    api: '',
    timeStamp: 0,
};

const toastMsg = (request, message) => {
    let showToast = false;
    if (request?.url && throttleToastObj.api !== request?.url) {
        throttleToastObj.api = request.url;
        throttleToastObj.timeStamp = Date.now().valueOf();
        showToast = true;
    } else {
        const now = Date.now().valueOf();
        if (now - throttleToastObj.timeStamp > 1000) {
            showToast = true;
            throttleToastObj.timeStamp = now;
        }
    }
    showToast && Toast.show(message);
};
request?.interceptors?.response.use(((response: any, originResponse?: any, request?: any, originRequest?: any, extraConfig?: any) => {
    const { toastError: krnApiToastError } = extraConfig || {};
    const { toastError: h5ApiToastError } = request?.extra || {};
    // 增加商详页预存的相关处理
    setTimeout(() => {
        try {
            setPrestoreDataFromRes({
                res: response,
                api: getUrlPathname(request?.url || ''),
            });
        } catch (e) {}
    }, 2000);
    const message = $k18n('系统繁忙，请稍后再试');
    if (response instanceof Error) {
        console.log('KRN_Ecomm_Defalut_Network_ErrorMessage', request, response);
        radar.event({
            name: 'KRN_Ecomm_Defalut_Network_ErrorMessage',
            params: {
                extData: {
                    request,
                    response,
                },
            },
        });
        if (krnApiToastError ?? h5ApiToastError ?? true) {
            toastMsg(request, message);
        }
        return Promise.reject(response);
    }
    // 4013 一般表示未登录，如未登录，则触发展示登录弹窗
    let isOmitPath = false;
    UN_AUTHORIZED_OMIT_PATHNAME.forEach(item => {
        if (window.location.pathname.includes(item)) {
            isOmitPath = true;
        }
    });
    if (response?.result === 4013 && !UN_AUTHORIZED_OMIT.includes(response?.url as string) && !isOmitPath) {
        if (!useLoginStore.getState().loginModelVisible) {
            useLoginStore.getState().setLoginModelVisible(true);
        }
        return response;
    }

    if (![1, 4013, 8214].includes(response?.result)) {
        if (krnApiToastError ?? h5ApiToastError ?? true) {
            toastMsg(request, response?.message || message);
        }
        return Promise.reject(response);
    }
    return response;
}) as any);

request?.interceptors?.request.use(
    // 风控要求header增加的参数
    config => {
        // 在请求头中添加自定义内容
        config.headers['web-req'] = true;
        config.headers['web-rp'] = getRiskControlData();
        console.log('interceptors =>', isDev, isStaging, isPRT);
        if (isDev || isStaging) {
            config.headers['trace-context'] = '{"laneId":"STAGING.ecom_seo"}';
        } else if (isPRT) {
            config.headers['trace-context'] = '{"laneId":"PRT.ecom_seo"}';
        }
        return config;
    }
);
function getBrowserInfo() {
    const userAgent = navigator.userAgent;
    const browserMatch = userAgent.match(/(Chrome|Firefox|Safari|Edg|Opera)\/(\d+\.\d+)/);

    return {
        appVersion: browserMatch[2] || '',
        appName: browserMatch[1] || '',
        appCodeName: browserMatch[1] || '',
    };
}
// 参考文档：https://docs.corp.kuaishou.com/k/home/VHgpLxSk9yCs/fcABKJI-ivoT5OWuTN5YgQ_rm#section=h.6z3o7jtykcww
export function getRiskControlData() {
    const {
        identity_package = {},
        app_package = {},
        device_package = {},
        network_package = {},
        h5_extra_attr = {},
    } = webLogger?.webLogger?.commonPackage || {};
    return JSON.stringify({
        ...app_package,
        ...identity_package,
        ...device_package,
        ...network_package,
        ...h5_extra_attr,
        ...getBrowserInfo(),
        entranceSource: 'pc',
        userAgentData: device_package.ua,
        raw_device_model: device_package.model,
        device_ua: device_package.ua,
        language: app_package?.language,
        resolution: h5_extra_attr.resolution,
        screenWidth: h5_extra_attr.screen_width,
        screenHeight: h5_extra_attr.screen_height,
        devicePixelRatio: h5_extra_attr.device_pixel_ratio,
        city_name: h5_extra_attr?.county_name?.county_name,
        deviceId: identity_package.device_id || cookies.get('did') || cookies.get('webDid'),
        deviceMemory: navigator?.deviceMemory,
        sessionId: webLogger?.webLogger?.sessionId,
    });
}
